export default __webpack_public_path__ + "static/media/TL.b96718d8.svg";